/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivateAgencyDto,
  ActivationResultDto,
  AgencyProfileDto,
  SignUpDto,
  SignUpResultDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAgenciesControllerGetMyAgencyV1Url = () => {




  return `/v1/agencies/me`
}

/**
 * @summary The caller's agency profile (read-only)
 */
export const agenciesControllerGetMyAgencyV1 = async ( options?: RequestInit): Promise<AgencyProfileDto> => {

  return apiRequest<AgencyProfileDto>(getAgenciesControllerGetMyAgencyV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAgenciesControllerGetMyAgencyV1QueryKey = () => {
    return [
    `/v1/agencies/me`
    ] as const;
    }


export const getAgenciesControllerGetMyAgencyV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerGetMyAgencyV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>> = ({ signal }) => agenciesControllerGetMyAgencyV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerGetMyAgencyV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>>
export type AgenciesControllerGetMyAgencyV1QueryError = unknown


export function useAgenciesControllerGetMyAgencyV1<TData = Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerGetMyAgencyV1<TData = Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerGetMyAgencyV1<TData = Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The caller's agency profile (read-only)
 */

export function useAgenciesControllerGetMyAgencyV1<TData = Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerGetMyAgencyV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerGetMyAgencyV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerActivateV1Url = () => {




  return `/v1/agencies/activate`
}

/**
 * @summary Activate an agency: root user redeems the emailed token
 */
export const agenciesControllerActivateV1 = async (activateAgencyDto: ActivateAgencyDto, options?: RequestInit): Promise<ActivationResultDto> => {

  return apiRequest<ActivationResultDto>(getAgenciesControllerActivateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activateAgencyDto)
  }
);}





export const getAgenciesControllerActivateV1QueryKey = (activateAgencyDto?: ActivateAgencyDto,) => {
    return [
    'POST', `/v1/agencies/activate`, activateAgencyDto
    ] as const;
    }


export const getAgenciesControllerActivateV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError = unknown>(activateAgencyDto: ActivateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerActivateV1QueryKey(activateAgencyDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerActivateV1>>> = ({ signal }) => agenciesControllerActivateV1(activateAgencyDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerActivateV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerActivateV1>>>
export type AgenciesControllerActivateV1QueryError = unknown


export function useAgenciesControllerActivateV1<TData = Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError = unknown>(
 activateAgencyDto: ActivateAgencyDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerActivateV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerActivateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerActivateV1<TData = Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError = unknown>(
 activateAgencyDto: ActivateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerActivateV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerActivateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerActivateV1<TData = Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError = unknown>(
 activateAgencyDto: ActivateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Activate an agency: root user redeems the emailed token
 */

export function useAgenciesControllerActivateV1<TData = Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError = unknown>(
 activateAgencyDto: ActivateAgencyDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerActivateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerActivateV1QueryOptions(activateAgencyDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgenciesControllerSignUpV1Url = () => {




  return `/v1/agencies/signup`
}

/**
 * @summary Self-signup: create an agency and its owner; a verification email follows
 */
export const agenciesControllerSignUpV1 = async (signUpDto: SignUpDto, options?: RequestInit): Promise<SignUpResultDto> => {

  return apiRequest<SignUpResultDto>(getAgenciesControllerSignUpV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signUpDto)
  }
);}





export const getAgenciesControllerSignUpV1QueryKey = (signUpDto?: SignUpDto,) => {
    return [
    'POST', `/v1/agencies/signup`, signUpDto
    ] as const;
    }


export const getAgenciesControllerSignUpV1QueryOptions = <TData = Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError = unknown>(signUpDto: SignUpDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgenciesControllerSignUpV1QueryKey(signUpDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>> = ({ signal }) => agenciesControllerSignUpV1(signUpDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgenciesControllerSignUpV1QueryResult = NonNullable<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>>
export type AgenciesControllerSignUpV1QueryError = unknown


export function useAgenciesControllerSignUpV1<TData = Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError = unknown>(
 signUpDto: SignUpDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerSignUpV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerSignUpV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerSignUpV1<TData = Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError = unknown>(
 signUpDto: SignUpDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agenciesControllerSignUpV1>>,
          TError,
          Awaited<ReturnType<typeof agenciesControllerSignUpV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgenciesControllerSignUpV1<TData = Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError = unknown>(
 signUpDto: SignUpDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Self-signup: create an agency and its owner; a verification email follows
 */

export function useAgenciesControllerSignUpV1<TData = Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError = unknown>(
 signUpDto: SignUpDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agenciesControllerSignUpV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgenciesControllerSignUpV1QueryOptions(signUpDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






